// external.js
//
// Opening outside pages from inside the app. Capacitor's Browser opens an
// in-app browser on iOS and Android and a new tab on the web, so a reader
// following a source link can always come straight back.

import { Browser } from '@capacitor/browser';

export const openExternal = async (url) => {
  if (!url) return;
  try {
    await Browser.open({ url });
  } catch (err) {
    console.error('Failed to open link:', err);
  }
};

// Keyboard parity for the span-as-link pattern the member pages use.
export const onActivate = (handler) => (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    handler();
  }
};